import React, { useState } from 'react';
import { Box, styled, Tooltip, TooltipProps, tooltipClasses } from '@mui/material';

interface EllipsisTextProps {
    text: string | React.ReactNode;
    message?: string;
}

export const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,
        boxShadow: theme.shadows[1],
        lineHeight: '20px',
        fontSize: '14px',
        fontWeight: 400,
        padding: '12px',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white,
        '&::before': {
            backgroundColor: theme.palette.common.white,
            border: '1px solid #999',
        },
    },
}));

const EllipsisText: React.FC<EllipsisTextProps> = ({ text }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const handleMouseOver = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.currentTarget.offsetWidth < event.currentTarget.scrollWidth) {
            setShowTooltip(true);
        }
    };

    return (
        <LightTooltip
            arrow
            open={!!text && showTooltip}
            title={text}
            placement='top'
            disableInteractive
            onMouseEnter={handleMouseOver}
            onMouseLeave={() => setShowTooltip(false)}
            data-testid="tooltip"
        >
            <Box
                component='div'
                sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    wordBreak: 'break-all',
                    whiteSpace: 'nowrap'
                }}
                data-testid="ellipsis-text"
            >
                {text}
            </Box>
        </LightTooltip>
    );
};

export default EllipsisText;
